import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CaseServices } from "../services/CaseServices";
import { RpaServices } from "../services/RpaServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
export const fetchActiveCasesCount = createAsyncThunk(
  "caseDetails/fetchACtiveCasesCount",
  async () => {
    const response = await CaseServices.getInactiveCaseCount();
    return (
      Number(response?.data?.totalSettlemedCases) -
      Number(response?.data?.filteredInactiveCases)
    );
  },
);
export const fetchUserAssignedCases = createAsyncThunk(
  "case/fetchUserAssignedCases",
  async () => {
    const response = await CaseServices.getUserAssignedCasesCount();
    return response?.data?.assignedCaseCount;
  },
);
export const fetchManageQueriesCount = createAsyncThunk(
  "caseDetails/fetchManageQueriesCount",
  async ({ status = "ACTIVE", searchKey = "", hospitalId = "" }) => {
    const response = await RpaServices.manageQueries(
      status,
      1,
      1,
      searchKey,
      hospitalId,
    );
    return response?.data?.total || 0;
  },
);

export const caseDetailSlice = createSlice({
  name: "caseDetail",
  initialState: {
    caseId: "",
    pageNo: "",
    member: "",
    status: "",
    subStatus: "",
    selectedHospitalId: "",
    selectedIsTpa: "",
    // HSA case list scheme filter (PMJAY | CGHS | TPA) — persists until user changes it
    selectedHsaScheme: "",
    activeCasesCount: "",
    assignedCasesCount: "",
    userAssignedStages: "",
    newCaseAddRequest: false,
    manageQueriesCount: 0,
    searchKey: "",
  },
  reducers: {
    updateCaseId: (state, action) => {
      state.caseId = action.payload == state.caseId ? null : action.payload;
    },
    updatePageNumber: (state, action) => {
      state.pageNo = action.payload;
    },
    updateMember: (state, action) => {
      state.member = action.payload;
    },
    updateStatus: (state, action) => {
      state.status = action.status;
    },
    updateSubStatus: (state, action) => {
      state.subStatus = action.payload;
    },
    updateSelectedHospital: (state, action) => {
      state.selectedHospitalId = action.payload;
    },
    updateSelectedIsTpa: (state, action) => {
      state.selectedIsTpa = action.payload;
    },
    updateSelectedHsaScheme: (state, action) => {
      state.selectedHsaScheme = action.payload;
    },
    setUserAssignedStages: (state, action) => {
      state.userAssignedStages = action.payload;
    },
    setNewCaseAddRequest: (state, action) => {
      state.newCaseAddRequest = action.payload;
    },
    setSearchKey: (state, action) => {
      state.searchKey = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActiveCasesCount.pending, (state) => {
        // state.status = "loading";
      })
      .addCase(fetchActiveCasesCount.fulfilled, (state, action) => {
        // state.status = "succeeded";
        state.activeCasesCount = action.payload; // Update notification count with API data
      })
      .addCase(fetchActiveCasesCount.rejected, (state, action) => {
        // state.status = "failed";
        state.error = action.error.message;
        handleApiErrorResponses(action.error);
      })
      .addCase(fetchUserAssignedCases.pending, (state) => {
        // state.status = "loading";
      })
      .addCase(fetchUserAssignedCases.fulfilled, (state, action) => {
        // state.status = "succeeded";
        state.assignedCasesCount = action.payload; // Update notification count with API data
      })
      .addCase(fetchUserAssignedCases.rejected, (state, action) => {
        // state.status = "failed";
        state.error = action.error.message;
        handleApiErrorResponses(action.error);
      })

      // ✅ Manage Queries Count
      .addCase(fetchManageQueriesCount.pending, (state) => {
        // state.status = "loading";
      })
      .addCase(fetchManageQueriesCount.fulfilled, (state, action) => {
        // state.status = "succeeded";
        state.manageQueriesCount = action.payload; // Save queries count
      })
      .addCase(fetchManageQueriesCount.rejected, (state, action) => {
        // state.status = "failed";
        state.error = action.error.message;
        handleApiErrorResponses(action.error);
      });
  },
});

export const {
  updateCaseId,
  updatePageNumber,
  updateMember,
  updateStatus,
  updateSubStatus,
  updateSelectedHospital,
  updateSelectedIsTpa,
  updateSelectedHsaScheme,
  setUserAssignedStages,
  setNewCaseAddRequest,
  setSearchKey,
} = caseDetailSlice.actions;

export default caseDetailSlice.reducer;
